import React from 'react';
import Stack from '@mui/material/Stack';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import FolderIcon from '@mui/icons-material/Folder';
import Typography from '@mui/material/Typography';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Folder = ({ isExpanded, onClick, label, count }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      onClick={onClick}
      sx={{ cursor: 'pointer', userSelect: 'none' }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        {isExpanded ? (
          <FolderOpenIcon color="primary" />
        ) : (
          <FolderIcon color="primary" />
        )}
        <Typography>{label}</Typography>
        {count > 0 && (
          <>
            <Typography
              variant="body2"
              sx={{
                borderRadius: '50%',
                backgroundColor: 'divider',
                lineHeight: 1.6,
                padding: 0.3,
                fontWeight: 600,
                textAlign: 'center',
                width: 24,
                height: 24,
              }}
            >
              {count}
            </Typography>
            {isExpanded ? (
              <KeyboardArrowUp fontSize="small" color="action" />
            ) : (
              <KeyboardArrowDownIcon fontSize="small" color="action" />
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default Folder;
